// import Vue from 'vue'
import 'view-design/dist/styles/iview.css';
import {Message,RadioGroup,Radio,Spin, Modal,Button,Carousel, CarouselItem,Input, Cascader,Select,Option,Avatar} from 'view-design';

Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Spin', Spin);
Vue.component('Modal', Modal);
Vue.component('i-button', Button);
Vue.component('Carousel', Carousel);
Vue.component('CarouselItem', CarouselItem);
Vue.component('i-input', Input);
Vue.component('Cascader', Cascader);
Vue.component('i-select', Select);
Vue.component('i-option', Option);
Vue.component('Avatar', Avatar);

Vue.prototype.$message = Message
Vue.prototype.$modal = Modal
Vue.prototype.$spin = Spin
